import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../../components/SeoHead";
import MainBanner from "../../../components/MainBanner";
import AllConsultants from "../../../components/AllConsultants";
import MultiColumnCTAWithDivider from "../../../components/MultiColumnCTAWithDivider";
import NewColumnWithForm from "../../../components/NewColumnWithForm";

export default function MeetTheTeam({ global, all_consultants }) {
  return (
    <>
      <SeoHead
        page_name={`Meet the Lorien Team | Technology Specialists`}
        description={`Meet the dedicated specialists behind Lorien, bringing deep experience and industry knowledge to support clients and candidates.`}
        canonical_link={`about-us/meet-the-team`}
      />
      <MainBanner
        global={global}
        pathPrefix={`meet_the_team_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Meet the Team</h1>
          </>
        }
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/sub-banner-about-us.png`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
        breadcrumb_title="Meet The Team"
        secondary_breadcrumb_url={"/about-us"}
        secondary_breadcrumb_title={"About Us"}
      />
      <AllConsultants
        global={global}
        pathPrefix={`meet_the_team_page.all_consultants`}
        customClass={`py-5 grayGradientBg`}
        content={
          <>
            <h2>Our Team</h2>
          </>
        }
        post={all_consultants}
      />
      <NewColumnWithForm 
          formId={`308d12ba-6cc4-44a5-91e2-76d1d714bf23`}
          successPageUrl={`/about-us/join-us/submission-success`}
      />
      {/* <MultiColumnCTAWithDivider
        global={global}
        pathPrefix={`meet_the_team_page.multi_column_cta`}
        customClass={`pt-5 pb-md-4 pb-5`}
        left_content={
          <>
            <h2>Get in Touch</h2>
          </>
        }
        right_content={
          <>
            <h2>Work for us</h2>
          </>
        }
        buttonLink2={`/`}
        buttonLink1={`/`}
        buttonTitle1={`Contact us`}
        buttonTitle2={`Join us now`}
      /> */}
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const consultants = (await Collection("consultants"))
    .filter(function (post) {
      return post.slt?.en === true;
    })
    .filter(function (post) {
      return post.country?.en == "UK";
    });
  const all_consultants = consultants.orderBy("_order").getItems();

  return {
    props: {
      global,
      all_consultants,
    },
  };
}
